import {Component,OnInit,NgZone,ViewChild} from '@angular/core';
import {PaymentRequests} from 'src/app/shared/models/paymentRequests';
import {PaymentRequestsBeneficiaries} from 'src/app/shared/models/paymentRequestsBeneficiaries';
import { ActivatedRoute, Router } from '@angular/router';
import {Subscription} from 'rxjs';
import notify from 'devextreme/ui/notify';
import {NgForm,FormBuilder,FormGroup} from '@angular/forms';
import {PaymentrequestsService} from 'src/app/shared/services/paymentrequests.service';
import {UtilitiesService} from 'src/app/shared/services/utilities.service';
import {CmgService} from 'src/app/shared/services/cmg.service';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import {PaymentrequestsBeneficiariesService} from 'src/app/shared/services/paymentrequests-beneficiaries.service';
import * as _ from 'lodash';
import { Company } from 'src/app/shared/models/companies';
import { User } from 'src/app/shared/models/users';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { UsersService } from '../../../shared/services/users.service';

class ImageSnippet {
  constructor(public src: string, public file: File) {}
}
export class FileUpload {
  url: string; 
  name: string;
}
export class FileItem {
  result: FileUpload[];
}

export class Attachment {
  constructor(public url: string, public file: File,public fileName: string,public is_ihunter: number) {}
}

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class PaymentRequestsFormComponent implements OnInit {
  udta: User;
  leaderName: any;
  allUsers: any[] = [];
  private subscription$: Subscription = new Subscription();
  paymentRequest: PaymentRequests;
  tempStartDate: any;
  beneficiariesCatalog: any[] = [];
  popupVisible: boolean = false;
  facturaSuperlativeVisible: boolean = false;
  cmgCatalog: any[] = [];
  cmgCategories: any;
  cmgSubCategories: any;
  cmgCategory: any;
  cmgSubCategory: any;
  requestSocial: any;
  companyData: any;
  beneficiaryTempId = null;
  cmgTempId = null;
  cmgData = [];
  paymentRequestCMG: string;
  remoteProvider: any;
  response_upload: Number;
  progress: number = 0;
  selectedFile: Attachment;
  files_preload : Attachment[] = [];
  files_to_load : Attachment[] = [];
  company: Company;
  emailCompany:string;
  isIva: boolean = false;

  constructor(
    private companiesService: CompaniesService,
    private route: ActivatedRoute,
    private router: Router,
    private utilitiesService: UtilitiesService,
    private paymentRequestsService: PaymentrequestsService,
    private cmgservice: CmgService,
    private usersService: UsersService,
    private paymentrequestsBeneficiariesService: PaymentrequestsBeneficiariesService,
  ) {
    
  }

  ngOnInit() {
    
    this.companyData = this.utilitiesService.getCompanyData();
    this.subscription$.add(
      this.paymentrequestsBeneficiariesService.getCompanyBeneficiaries(this.companyData.id).subscribe(beneficiaries => {
        console.log(beneficiaries);
        this.beneficiariesCatalog = beneficiaries.sort((a, b) => { return (a.beneficiaryComercialName > b.beneficiaryComercialName ? 1 : (a === b ? 0 : -1)) });
      })
    );
    this.subscription$.add(
      this.companiesService.getCompany(this.companyData.id).subscribe(company => {
        this.emailCompany = company.contactEmail;
      })
    );
    if (this.route.snapshot.params['id']!=undefined) {
      this.getAllUsers();
    } else {
      this.getAllUsersOnly();
      this.paymentRequest = new PaymentRequests;
      this.paymentRequest.companyId = this.companyData.id;
      this.paymentRequest.companyName = this.companyData.companyName;
      this.paymentRequest.dateCreated = this.utilitiesService.dateToNumber(new Date());
    }
    this.getCMGCatalog();
    this.requestSocial = this.cmgservice.getSocialRassonRequest();
    this.udta = this.utilitiesService.getUserData();
    if (this.udta.level < 4) {
      this.facturaSuperlativeVisible = true;
    }
  }
  getAllUsersOnly(){
    this.usersService.getAllUsers().subscribe(res =>{
      this.allUsers = res;
    });
  }
  getAllUsers(){
    this.usersService.getAllUsers().subscribe(res =>{
      this.allUsers = res;
      this.subscription$.add(
        this.paymentRequestsService.getPaymentRequestEdit(this.route.snapshot.params['id'],this.companyData.id).subscribe(request => {
          this.paymentRequest = request['payments_rows'][0];
          this.paymentRequestCMG = request['payments_rows'][0].cmg.cmg;
          const user = this.allUsers.filter(f => f.uid == request['payments_rows'][0].cmg.leader)
          this.leaderName = user[0] ? user[0].name : '';
          // this.getLlenaCombosCMGEdit(this.paymentRequest.cmg.cmg);
          this.files_preload=request['payments_rows'][0].attachments;
          if(this.paymentRequest.tax>0){
            this.isIva=true;
            this.paymentRequest.fee = this.paymentRequest.amount * .06;
            this.paymentRequest.tax = (this.paymentRequest.amount + this.paymentRequest.fee) * .16;
            this.paymentRequest.total = this.paymentRequest.amount + this.paymentRequest.fee + this.paymentRequest.tax;
          }
        })
      );
    });
  }
  // getLlenaCombosCMGEdit(cmg: string){
  //   this.cmgservice.getLlenaCombosCMGEdit(cmg).subscribe(res =>{
  //     const { cmgId, categoryGroupId, categoryId, subCategoryId } = res.data[0];
  //     this.cmgCategory = categoryId;
  //     this.cmgSubCategory = subCategoryId;
  //   })
  // }
  getCMGCatalog(){
    this.cmgservice.getCMGCatalog().subscribe(res =>{
      this.cmgCatalog = res.data;
    });
  }
  onValueChangedApp($event,mount){
    if(this.isIva){
      this.paymentRequest.fee = mount * .06;
      this.paymentRequest.tax = (mount + this.paymentRequest.fee) * .16;
      this.paymentRequest.total = mount + this.paymentRequest.fee + this.paymentRequest.tax;
    }else{
      this.paymentRequest.fee = mount * .06;
      this.paymentRequest.tax = 0;
      this.paymentRequest.total = mount + this.paymentRequest.fee;
    }
  }

  calculateFees(e) {
    if(this.isIva){
      this.paymentRequest.fee = e * .06;
      this.paymentRequest.tax = (e + this.paymentRequest.fee) * .16;
      this.paymentRequest.total = e + this.paymentRequest.fee + this.paymentRequest.tax;
    }else{  
      this.paymentRequest.fee = e * .06;
      this.paymentRequest.tax = 0;
      this.paymentRequest.total = e + this.paymentRequest.fee;
    }
  }

  checkCompany(e) {
    let beneficiaryCompanyData = this.beneficiariesCatalog.filter(company => company.id == e);
    this.paymentRequest.beneficiary = beneficiaryCompanyData[0];
    this.paymentRequest.beneficiary.id=e;
    this.paymentRequest.beneficiaryIsInc = beneficiaryCompanyData[0].beneficiaryIsInc;
  }

  createNewBeneficiary() {
    this.router.navigate(['/dash/payment-beneficiaries/new/newreq']);
  }

  processFile(fileSelected: any): void {
    const file: File = fileSelected.files[0];
    const reader = new FileReader();
    reader.addEventListener('load', (event: any) => {
      this.selectedFile = new Attachment(event.target.result,file,file.name,this.udta.level);
      this.files_preload.push(this.selectedFile);
      this.files_to_load.push(this.selectedFile);
      this.response_upload = 4;
      setTimeout(() => {
        this.progress = 0;
        this.response_upload = 0;
      }, 1500);
    });
    reader.readAsDataURL(file);    
  }

  async onFormUpdateSubmit(data) {
    this.paymentRequest.createdBy = this.udta.name + ' ' + this.udta.lastName;
    this.paymentRequest.idCreatedBy = this.udta.id;
    if (data.validationGroup.validate().isValid) {
      this.subscription$.add(
          this.paymentRequestsService.newPaymentRequest(
            this.paymentRequest,
            this.files_to_load,
            this.companyData.id,
            this.companyData.companyName,
            this.emailCompany,
            ''+this.udta.level
            ).subscribe(entry => {
              this.utilitiesService.notifyMe('Solicitud ha sido enviada', 'success');
              this.router.navigate(['/dash/payment-requests']);
          })
      )
    }
  }
  getCmgData(e) {
    this.cmgData = [];
    let copiaCmgCatalog = [...this.cmgCatalog];
    this.cmgData = copiaCmgCatalog.filter(cat => cat.cmg === e);
    this.paymentRequest.cmg = this.cmgData[0];
    const user = this.allUsers.filter(f => f.uid == this.paymentRequest.cmg.leader)
          this.leaderName = user[0] ? user[0].name : '';
  }

  getRequestSocilData(e){
    let requestSocialData = this.requestSocial.filter(cat => cat.name === e);
    this.paymentRequest.requestSocial = requestSocialData[0].name;
  }


  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

}